import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';
import { QRCodeSVG } from 'qrcode.react';
import { generateQRUrl } from '../config/qrConfig';
import './LabelPreview.css';

function LabelPreview({ item }) {
  const barcodeRef = useRef(null);

  useEffect(() => {
    if (item && item.sku && barcodeRef.current) {
      try {
        JsBarcode(barcodeRef.current, item.sku, {
          format: 'CODE128',
          width: 1,
          height: 40,
          displayValue: false,
          margin: 0
        });
      } catch (error) {
        console.error('Barcode generation failed:', error);
      }
    }
  }, [item]);

  // UPC barcode removed - no longer needed

  if (!item) return null;

  // Format date in reverse order without slashes (e.g., 20250921 -> 52021290)
  const today = new Date();
  const year = today.getFullYear().toString().slice(-2); // Last 2 digits of year
  const month = (today.getMonth() + 1).toString().padStart(2, '0');
  const day = today.getDate().toString().padStart(2, '0');
  // Reverse the order: year (reversed) + month (reversed) + day (reversed)
  const formattedDate = year.split('').reverse().join('') + 
                        month.split('').reverse().join('') + 
                        day.split('').reverse().join('');

  // Determine logo based on SKU prefix
  const getLogo = () => {
    const sku = item.sku?.toUpperCase() || '';
    if (sku.startsWith('RW')) {
      return '/rewined_logo.jpg';
    } else if (sku.startsWith('CF')) {
      return '/candlefish_logo.jpg';
    }
    return null;
  };

  const logoSrc = getLogo();

  // Generate QR code URL for mobile operations
  // IMPORTANT: This URL is printed on physical labels that may last 1+ years
  const qrUrl = generateQRUrl(item.sku);

  return (
    <div className="label-preview">
      <div className="label-content">
        <div className="label-top-section">
          <div className="label-left-column">
            {logoSrc ? (
              <img src={logoSrc} alt="Brand Logo" className="label-logo" />
            ) : (
              <div className="label-brand">{typeof item.brand === 'object' ? item.brand.refName || '' : item.brand || ''}</div>
            )}
            <div className="label-barcode-section">
              <svg ref={barcodeRef}></svg>
            </div>
            <div className="label-sku">{item.sku}</div>
            <div className="label-case-qty">CS QTY: {item.case_qty}</div>
          </div>

          <div className="label-right-column">
            <div className="label-qr-section">
              <QRCodeSVG
                value={qrUrl}
                size={100}
                level="M"
                includeMargin={false}
              />
              <div className="label-qr-text">OPS</div>
            </div>
            <div className="label-date">{formattedDate}</div>
          </div>
        </div>

        <div className="label-bottom-section">
          <div className="label-description">
            {item.description}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LabelPreview;